export default [
  {
    content: "플러그나 스위치를 젖은 손으로 조작 또는 취급 금지",
    isChecked: "",
  },
  {
    content: "고속절단기에 접속되어 있는 전원에 누전차단기 설치 및 외함접지를 실시",
    isChecked: "",
  },
  {
    content: "전원코드는 정기적으로 점검하고 사용하지 않을 때에는 전원코드를 뽑아 놓음",
    isChecked: "",
  },
  {
    content: "절단지석의 파손여부를 확인하고 손상, 원형 상태 불량 및 흔들리는 절단지석은 교체",
    isChecked: "",
  },
  {
    content: "절단지석을 견고하게 고정하고, 올바르게 조립되었는지 또는 원활하게 돌아가는지 스위치를 켜기 전에 확인",
    isChecked: "",
  },
  {
    content: "금속, 비철금속 절단 등 절단물 재질에 적합한 절단지석을 사용",
    isChecked: "",
  },
  {
    content: "각 부에 장치되어 있는 나사가 느슨해져 있는 지 점검",
    isChecked: "",
  },
  {
    content: "절단물은 안정된 상태로 흔들림 없이 완전하게 고정",
    isChecked: "",
  },
  {
    content: "전동공구에 충격을 주면 절단지석에 금이 가거나 흠이 생길 우려가 있으므로 취급에 주의",
    isChecked: "",
  },
  {
    content: "절단지석을 회전시킨 채 절단물을 빼거나 장치하는 행위 금지",
    isChecked: "",
  },
  {
    content: "작업 후 절단지석의 회전이 완전히 멈추는 것을 확인",
    isChecked: "",
  },
  {
    content: "절단 후 바로 공작물을 만지지 말고 충분히 식혀서 취급",
    isChecked: "",
  },
  {
    content: "방진 마스크, 안전화, 안전모, 귀마개 등 개인 보호구를 착용",
    isChecked: "",
  },
];
